(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[72],{

/***/ "Adz/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vOnD");

var ButtonBox = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "ButtonBox",
  componentId: "u715n-0"
})(["position:relative;width:100%;display:flex;flex-direction:column;align-items:center;a{display:flex;justify-content:center;align-items:center;&:nth-child(2){margin-top:", "px;}}"], function (props) {
  return props.theme.baseline;
});
/* harmony default export */ __webpack_exports__["a"] = (ButtonBox);

/***/ }),

/***/ "Skfu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./styles/theme.js
var theme = __webpack_require__("NVT0");

// CONCATENATED MODULE: ./components/pages/FrontPage/Reviews/Rating.js

var Rating = styled_components_browser_esm["default"].img.withConfig({
  displayName: "Rating",
  componentId: "tk3jjk-0"
})(["margin:0 auto;width:", "px;height:100%;margin-top:auto;@media ", "{margin-top:", ";width:", "px;}"], function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.halfBaseline / 2;
}, function (props) {
  return props.theme.halfBaseline * 5;
});
/* harmony default export */ var Reviews_Rating = (Rating);
// CONCATENATED MODULE: ./components/pages/FrontPage/Reviews/Rater.js

var Rater = styled_components_browser_esm["default"].img.withConfig({
  displayName: "Rater",
  componentId: "jel32j-0"
})(["margin:", "px auto 0 auto;width:100%;height:100%;@media ", "{margin-top:", "px;}"], function (props) {
  return props.theme.halfBaseline * 3;
}, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.baseline * 3;
});
/* harmony default export */ var Reviews_Rater = (Rater);
// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./components/atoms/Link/index.tsx
var Link = __webpack_require__("ZT91");

// EXTERNAL MODULE: ./components/atoms/Button/index.js + 7 modules
var Button = __webpack_require__("8BE4");

// EXTERNAL MODULE: ./utils/generateClickableId.js
var generateClickableId = __webpack_require__("7dJx");

// EXTERNAL MODULE: ./components/pages/FrontPage/ButtonBox/index.js
var ButtonBox = __webpack_require__("Adz/");

// CONCATENATED MODULE: ./components/pages/FrontPage/Reviews/ReviewButton.js
var __jsx = react_default.a.createElement;








var ReviewButton_ReviewButton = function ReviewButton() {
  return /*#__PURE__*/react_default.a.createElement(ButtonWrapper, null, /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: "/products/soundboks-gen-3/reviews"
  }, /*#__PURE__*/react_default.a.createElement(Button["e" /* StandardButton */], {
    id: Object(generateClickableId["a" /* generateClickableId */])(1, 'Home', 'Reviews', 'Reviews')
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SEE ALL REVIEWS"
  }))));
};

var ButtonWrapper = Object(styled_components_browser_esm["default"])(ButtonBox["a" /* default */]).withConfig({
  displayName: "ReviewButton__ButtonWrapper",
  componentId: "sc-1gtuxpa-0"
})(["position:absolute;bottom:-", "px;margin-top:", "px;a{margin-top:0;border-radius:", ";background-color:", ";}"], function (props) {
  return props.theme.baseline * 3;
}, function (props) {
  return props.theme.baseline * 3;
}, function (props) {
  return props.theme.sizes.radius;
}, function (props) {
  return props.theme.colors.white;
});
/* harmony default export */ var Reviews_ReviewButton = (ReviewButton_ReviewButton);
// EXTERNAL MODULE: ./components/atoms/Text/index.js + 17 modules
var Text = __webpack_require__("wCgk");

// CONCATENATED MODULE: ./components/pages/FrontPage/Reviews/ReviewText.js
var ReviewText_jsx = react_default.a.createElement;





var ReviewText_ReviewText = function ReviewText(_ref) {
  var quote = _ref.quote;
  return /*#__PURE__*/react_default.a.createElement(StyledReviewText, null, quote);
};

var StyledReviewText = Object(styled_components_browser_esm["default"])(Text["a" /* BodyTextHighlight */]).withConfig({
  displayName: "ReviewText__StyledReviewText",
  componentId: "sc-14sonj8-0"
})(["font-weight:300;text-align:center;margin:", "px auto ", "px auto;width:", "px;@media ", "{width:", "px;margin-top:", "px;}@media ", "{width:", "px;margin-top:", "px;margin-bottom:", "px;}"], theme["a" /* default */].halfBaseline * 5, theme["a" /* default */].baseline * 2, theme["a" /* default */].baseline * 31, theme["a" /* default */].breakpoints.tablet, theme["a" /* default */].halfBaseline * 69, theme["a" /* default */].halfBaseline * 5, theme["a" /* default */].breakpoints.desktopLarge, theme["a" /* default */].halfBaseline * 111, theme["a" /* default */].halfBaseline * 15, theme["a" /* default */].baseline * 7);
/* harmony default export */ var Reviews_ReviewText = (ReviewText_ReviewText);
// CONCATENATED MODULE: ./components/pages/FrontPage/Reviews/index.js
var Reviews_jsx = react_default.a.createElement;








var Reviews_Reviews = function Reviews(_ref) {
  var quote = _ref.quote,
      raterImg = _ref.raterImg,
      raterAlt = _ref.raterAlt;
  return /*#__PURE__*/react_default.a.createElement(StyledReviews, null, /*#__PURE__*/react_default.a.createElement(ImgWrapper, {
    forRating: true
  }, /*#__PURE__*/react_default.a.createElement(Reviews_Rating, {
    alt: "Rating stars",
    src: "/static/icons/star_solid_white.svg"
  }), /*#__PURE__*/react_default.a.createElement(Reviews_Rating, {
    alt: "Rating stars",
    src: "/static/icons/star_solid_white.svg"
  }), /*#__PURE__*/react_default.a.createElement(Reviews_Rating, {
    alt: "Rating stars",
    src: "/static/icons/star_solid_white.svg"
  }), /*#__PURE__*/react_default.a.createElement(Reviews_Rating, {
    alt: "Rating stars",
    src: "/static/icons/star_solid_white.svg"
  }), /*#__PURE__*/react_default.a.createElement(Reviews_Rating, {
    alt: "Rating stars",
    src: "/static/icons/star_solid_white.svg"
  })), /*#__PURE__*/react_default.a.createElement(Reviews_ReviewText, {
    quote: quote
  }), /*#__PURE__*/react_default.a.createElement(ImgWrapper, null, /*#__PURE__*/react_default.a.createElement(Reviews_Rater, {
    alt: raterAlt,
    src: raterImg
  })), /*#__PURE__*/react_default.a.createElement(Reviews_ReviewButton, null));
};

var StyledReviews = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Reviews__StyledReviews",
  componentId: "sc-1wpsvhn-0"
})(["float:left;position:relative;width:100%;background-color:", ";color:", ";padding-top:", "px;padding-bottom:", "px;margin-top:-", "px;@media ", "{padding-bottom:", "px;}"], theme["a" /* default */].colors.black, theme["a" /* default */].colors.white, theme["a" /* default */].baseline * 4, theme["a" /* default */].baseline * 11, theme["a" /* default */].halfBaseline / 2, theme["a" /* default */].breakpoints.desktopLarge, theme["a" /* default */].baseline * 15);
var ImgWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Reviews__ImgWrapper",
  componentId: "sc-1wpsvhn-1"
})(["width:", "px;display:flex;justify-content:center;margin-left:auto;margin-right:auto;@media ", "{width:", "px;}@media ", "{width:", "px;}"], function (props) {
  return props.forRating ? props.theme.baseline * 13 : props.theme.baseline * 12;
}, theme["a" /* default */].breakpoints.tablet, function (props) {
  return props.forRating ? props.theme.halfBaseline * 28 : props.theme.baseline * 10;
}, theme["a" /* default */].breakpoints.desktopLarge, theme["a" /* default */].halfBaseline * 37);
/* harmony default export */ var FrontPage_Reviews = __webpack_exports__["default"] = (Reviews_Reviews);

/***/ })

}]);